"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "costa-masnaga": {
    "c8025f42": [{
      "hkey": "db910ba8",
      "slug": "camisasca-brenno",
      "name": "Camisasca-Brenno",
      "primary": true,
      "skipSearch": false
    }],
    "brenno-della-torre": [{
      "hkey": "db910ba8",
      "slug": "camisasca-brenno",
      "name": "Camisasca-Brenno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "costa-masnaga"
    }],
    "320127d5": [{
      "hkey": "db910ba8",
      "slug": "camisasca-brenno",
      "name": "Camisasca-Brenno",
      "primary": true,
      "skipSearch": false
    }],
    "camisacca": [{
      "hkey": "db910ba8",
      "slug": "camisasca-brenno",
      "name": "Camisasca-Brenno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cd7531ef": [{
      "hkey": "d33e2907",
      "slug": "costa-masnaga",
      "name": "Costa Masnaga",
      "primary": true,
      "skipSearch": false
    }],
    "centemero": [{
      "hkey": "d33e2907",
      "slug": "costa-masnaga",
      "name": "Costa Masnaga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "132770b4": [{
      "hkey": "d33e2907",
      "slug": "costa-masnaga",
      "name": "Costa Masnaga",
      "primary": true,
      "skipSearch": false
    }],
    "musico": [{
      "hkey": "d33e2907",
      "slug": "costa-masnaga",
      "name": "Costa Masnaga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bf7356b3": [{
      "hkey": "d33e2907",
      "slug": "costa-masnaga",
      "name": "Costa Masnaga",
      "primary": true,
      "skipSearch": false
    }],
    "samarino": [{
      "hkey": "d33e2907",
      "slug": "costa-masnaga",
      "name": "Costa Masnaga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;